import React, { useEffect, useState } from "react";
import { configs, formatCurrency, formatNumber } from "../../../assets/Config";
import { useLogin } from "../../../services/contexts/AdminLoginContext";
import LeftBarPage from "../../includes/dashboard/LeftBarPage";
import TopBarPage from "../../includes/dashboard/TopBarPage";
import "../../../assets/styles/BuyOrder.css"
import ToastPage from "../../includes/ToastPage";
import { useHistory } from "react-router";
import ManualPunchComponent from "./ManualPunchComponent";
import { useBuyOrderContext } from "../../../services/contexts/BuyOrdersContext";

export default function ManualPunchPage() {

    const { setCurrModule, setShowSuccess, allowedFunc, token, logout, setLoginError } = useLogin()
    const { setEditManualPunch } = useBuyOrderContext();

    const history = useHistory()


    useEffect(() => {
        try {
            if (allowedFunc.includes(configs.functionList["buy_module:buy_order_manual_punching"]) || allowedFunc.includes(configs.functionList["sell_module:sell_order_manual_punching"]) || allowedFunc.includes(configs.functionList['buy_module:load_all_buy_orders']) || allowedFunc.includes(configs.functionList['buy_module:update_buy_order'])) {
                setCurrModule(configs.modules.manualPunch)
                setEditManualPunch(false)
            } else {
                return history.goBack()
            }
        } catch (error) {
            console.error(error)
        }
    }, [])


    return (
        <>
            <TopBarPage />
            <div style={{ display: "flex" }}>
                <LeftBarPage />
                <ManualPunchComponent />
                <ToastPage />
            </div >
        </>
    )
}